import { Form, InputRef } from 'antd';
import PercentInput from 'components/CurrencyInputPrecision/PercentInput';
import Modal from 'components/Modal';
import { NumberPadIntV2 } from 'components/NumberKeyBoard/Currency/NumberPadV2';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
type Ref = {
  open: (_initialDuration: number) => Promise<number>;
};
type Props = {
};
export const useModalDurationsRef = () => useRef<Ref>(null);
const ModalDurations = forwardRef<Ref, Props>((_, ref) => {
  const [visible, setVisible] = useState(false);
  const [initialDuration, setInitialDuration] = useState(0);
  const inputDiscountValueRef = useRef<InputRef>(null);
  const [form] = Form.useForm();
  const callbackRef = useRef<((val: number) => void) | null>(null);
  const onClose = () => {
    setVisible(false);
    callbackRef.current?.(0);
    callbackRef.current = null;
  };
  const handleSubmit = (values: any) => {
    callbackRef.current?.(values.amount);
    onClose();
  };
  useImperativeHandle(ref, () => ({
    open: (_initialDuration: number) => {
      form.resetFields();
      setInitialDuration(_initialDuration);
      setVisible(true);
      setTimeout(() => {
        inputDiscountValueRef.current?.focus();
      }, 100);
      return new Promise<number>((resolve) => {
        callbackRef.current = resolve;
      });
    },
  }));
  return (
    <Modal noneBodyStyle width={900} visible={visible} onSubmit={() => form.submit()} modalTitle='DURATION (minutes)' v2 onClose={onClose}>
      <Container form={form} onFinish={handleSubmit} >
        <Form.Item name={'amount'} noStyle>
          <PercentInput
            height={64}
            inputRef={inputDiscountValueRef}
            inputMode='none' className='gift-card-number-input fs-big fs-medium' size='small'
            onChangeDebounce={() => form.validateFields(['amount'])}
            maxValue={1000}
            nonSymbol
            placeholder={`${initialDuration}m`}
          />
        </Form.Item>
        <Form.Item noStyle name={'amount'}>
          <NumberPadIntV2
            controlRef={inputDiscountValueRef}
            max={1000}
            onChange={() => form.validateFields(['amount'])}
          />
        </Form.Item>
      </Container>
    </Modal>
  );
});
ModalDurations.displayName = 'ModalDurations';
export default ModalDurations;
const Container = styled(Form)`
padding: 16px 0;
.gift-card-number-input {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  align-self: stretch;
  font-size: 30px;
  height: unset;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  outline: none;
  box-shadow: none;
  &.fs-big {
    font-size: 55px;
  }
  &.fs-medium {
    font-size: 45px;
  }
}
`;